var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18.62","height":"10.29"}},[_c('path',{attrs:{"d":"M17.91.7 9.33 9.8.71.7","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }